import React, { useState } from 'react';
import moment from 'moment';
import { Pagination, PaginationItem, PaginationLink, InputGroup, Input, InputGroupAddon, InputGroupText } from 'reactstrap';
import { usePercentageHistory } from './api';
import { useModalContext } from '../../../contexts/ModalContext';
import { useDebounce } from '../../../hook/debounce';

const TopupIncome = () => {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const { search, setSearch } = useModalContext()
    
        const searchText = useDebounce(search)
    const { data: percentage } = usePercentageHistory({
        page, size: rowsPerPage ,searchText
    })

    const totalPages = Math.ceil(percentage?.data[0]?.pagination?.total / rowsPerPage);

    const handlePageChange = (newPage) => {
        if (newPage >= 0 && newPage < totalPages) {
            setPage(newPage);
        }
    };
    return (


        <div>

            <div className="px-4 mb-3">
                <div className='row justify-content-between'>
                    <div className="col-md-6 mb-2 mb-md-0 text-center text-md-left">
                        <div className='d-inline-flex g-8 align-items-center'>
                            <span className='fs-18 fw-400 text-white-60'>Show</span>
                            <div className='form-group mb-0 formInputs gradientBg'>
                                <select className='form-control' value={rowsPerPage} onChange={(e) => {
                                    setRowsPerPage(Number(e.target.value));
                                    setPage(0);
                                }}>
                                    <option value="10">10</option>
                                    <option value="30">30</option>
                                    <option value="50">50</option>
                                </select>
                            </div>
                            <span className='fs-18 fw-400 text-white-60'>entries</span>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-inline justify-content-md-end justify-content-center'>
                            <div className="formInputs form-group gradientBg">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend" tag='div'>
                                        <InputGroupText className='pl-0'>
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2.25 7.5C2.25 8.18944 2.3858 8.87213 2.64963 9.50909C2.91347 10.146 3.30018 10.7248 3.78769 11.2123C4.2752 11.6998 4.85395 12.0865 5.49091 12.3504C6.12787 12.6142 6.81056 12.75 7.5 12.75C8.18944 12.75 8.87213 12.6142 9.50909 12.3504C10.146 12.0865 10.7248 11.6998 11.2123 11.2123C11.6998 10.7248 12.0865 10.146 12.3504 9.50909C12.6142 8.87213 12.75 8.18944 12.75 7.5C12.75 6.81056 12.6142 6.12787 12.3504 5.49091C12.0865 4.85395 11.6998 4.2752 11.2123 3.78769C10.7248 3.30018 10.146 2.91347 9.50909 2.64963C8.87213 2.3858 8.18944 2.25 7.5 2.25C6.81056 2.25 6.12787 2.3858 5.49091 2.64963C4.85395 2.91347 4.2752 3.30018 3.78769 3.78769C3.30018 4.2752 2.91347 4.85395 2.64963 5.49091C2.3858 6.12787 2.25 6.81056 2.25 7.5Z" stroke="white" strokeOpacity="0.6" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M15.75 15.75L11.25 11.25" stroke="white" strokeOpacity="0.6" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input type='text' placeholder='Search' value={search} onChange={(e) => setSearch(e.target.value)} />
                                </InputGroup>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='table-responsive mb-3'>
                <table className='table myapptable table-hover table-borderless mb-0'>
                    <thead>
                        <tr>
                            <th className='pl-4 text-nowrap'>MemberID By</th>
                            <th className='text-nowrap'>Username By	</th>
                            <th>Level</th>
                            <th className='text-nowrap'>Refferal Income</th>
                            <th className='text-right pr-4 text-nowrap'>Date & Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            percentage?.data[0] && percentage.data[0].data?.length > 0 ? (
                                percentage.data[0].data?.map((v, i) => (
                                    <tr key={v?._id}>
                                        <td className='pl-4 text-nowrap'>{v?.memberIdby ? v?.memberIdby : "--"}</td>
                                        <td>{v?.usernameby ? v?.usernameby : "--"}</td>
                                        <td className='text-nowrap'>{v?.level ? v?.level : "--"}</td>
                                        <td className='text-nowrap'>{v?.amount ? v?.amount : "--"}</td>
                                        <td className='text-right pr-4 text-nowrap'>
                                            <span>{moment(v.createdAt).format("DD/MM/YYYY | hh:mm A")}</span>
                                        </td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center">No data found</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
            <div className="px-4">
                <div className='row'>
                    {percentage?.data[0]?.pagination?.total &&

                        <div className='col-lg-12'>
                            <Pagination aria-label="Page navigation" className='customPagination'>

                                <PaginationItem disabled={page === 0}>
                                    <PaginationLink previous href="#" onClick={() => handlePageChange(page - 1)} className='prevbtn'>
                                        <i className='bi bi-arrow-left align-bottom'></i> Previous
                                    </PaginationLink>
                                </PaginationItem>
                                <span className='number'>
                                    {Array.from({ length: totalPages }, (_, index) => (
                                        <PaginationItem key={index} active={index === page}>
                                            <PaginationLink href="#" onClick={() => handlePageChange(index)}>
                                                {index + 1}
                                            </PaginationLink>
                                        </PaginationItem>
                                    ))}

                                </span>

                                <PaginationItem disabled={page === totalPages - 1}>
                                    <PaginationLink next href="#" onClick={() => handlePageChange(page + 1)} className='nextbtn'>
                                        Next <i className='bi bi-arrow-right align-bottom'></i>
                                    </PaginationLink>
                                </PaginationItem>
                            </Pagination>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default TopupIncome
